import { createContext, useContext } from 'react';
import { UiStore } from './UiStore';
import { ContentStore } from './ContentStore';
import { AuthStore } from './AuthStore';
// import { wsService } from '@/services/WebSocketService'; // 백엔드 준비 후 활성화

// 루트 스토어 — 모든 도메인 스토어를 묶고 상호 참조 주입
export class RootStore {
  ui: UiStore;
  content: ContentStore;
  auth: AuthStore;

  constructor() {
    this.content = new ContentStore();
    this.ui = new UiStore();
    this.auth = new AuthStore();   // 웹 회원 인증(토큰·role) — 헤더 분기·체험하기 게이팅·마이페이지
    this.ui.setProductCount(this.content.products.length);

    // 백엔드(STS/Java, WebSocket) 준비 시:
    // wsService.connect();
    // wsService.on('content:main', (p) => this.content /* apply */);
  }
}

export const rootStore = new RootStore();

const StoreContext = createContext<RootStore>(rootStore);
export const StoreProvider = StoreContext.Provider;

export const useStore = () => useContext(StoreContext);
export const useUi = () => useContext(StoreContext).ui;
export const useContent = () => useContext(StoreContext).content;
export const useAuth = () => useContext(StoreContext).auth;
